export default __webpack_public_path__ + "static/media/search.14d54d41.svg";